<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input ttLabel="poh_keyno_top" [ttModel]="edit.poh_keyno_top" [ttButtons]="pohKeynoTopButtons" ttReadonly></tt-input>
            <tt-input ttLabel="po_keyno" [ttModel]="edit.po_keyno" ttReadonly></tt-input>
            <tt-input *ngIf="edit.show_goto_product === '0'" ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly></tt-input>
            <tt-input *ngIf="edit.show_goto_product === '1'" ttLabel="prod_id" [ttModel]="edit.prod_id" [ttButtons]="prodIdButtons" ttReadonly></tt-input>
            <tt-input ttLabel="prod_name_long" [ttModel]="edit.prod_name_long" ttReadonly></tt-input>
            <tt-input-number ttLabel="quantity" [ttModel]="edit.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="quantity_finished" [ttModel]="edit.quantity_finished" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-select ttLabel="postatus" [(ttModel)]="edit.postatus_no" [ttData]="selectListPoStatuses" ttDataId="postatus_no" ttDataName="postatus_name"></tt-select>
            <tt-date ttLabel="lastdt_finish" [(ttModel)]="edit.lastdt_finish"></tt-date>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto [ttText]="'po_stockget'" [ttGoto]="'stockget'" [ttGotoParms]="{ stock_keyno: edit.stock_keyno }"></tt-button-goto>
        </tt-card>
    </div>

    <tt-card class="col-xs-12 col-md-8 p-5">
        <tt-button-save ttText="po_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button ttText="po_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
